export default __webpack_public_path__ + "static/media/5.329e8e42.png";